(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 1199px)'); // BUILD-xxxvii: header height re-measured at the burger/inline switch
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // liftsets (BUILD-ix/x): open mega/dropdown menus on hover for mouse users; a mouse click on a parent that
  // is already open goes to its collection (summary[data-href]) instead of toggling the panel shut. Touch (first
  // tap opens) and keyboard (Enter/Space toggle, Escape closes) keep Dawn's own header-menu behaviour.
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');
      if (!details || !summary) return;
      let timer;
      const open = () => {
        window.clearTimeout(timer);
        if (details.open) return;
        document.querySelectorAll('.header__inline-menu details[open]').forEach((d) => {
          if (d !== details) d.removeAttribute('open');
        });
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        timer = window.setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 120);
      };
      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', close);
      summary.addEventListener('click', (event) => {
        const href = summary.dataset.href;
        if (!href || event.pointerType !== 'mouse' || !details.open) return;
        event.preventDefault();
        window.location.assign(href);
      });
    });
  }

  // liftsets (BUILD-xi): category strip pills are links (as on the reference); hovering or focusing one also
  // highlights the matching group column below it.
  document.querySelectorAll('.mega-menu__strip').forEach((strip) => {
    const panel = strip.closest('.mega-menu__content');
    const cols = panel ? panel.querySelectorAll('.mega-menu__col[data-mega-group]') : [];
    const hot = (index) => cols.forEach((col) => col.classList.toggle('is-hot', !!index && col.dataset.megaGroup === index));
    strip.addEventListener('pointerover', (event) => {
      const pill = event.target.closest('[data-mega-group]');
      if (pill) hot(pill.dataset.megaGroup);
    });
    strip.addEventListener('focusin', (event) => {
      const pill = event.target.closest('[data-mega-group]');
      if (pill) hot(pill.dataset.megaGroup);
    });
    strip.addEventListener('pointerleave', () => hot(''));
    strip.addEventListener('focusout', () => hot(''));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsus-bought-together"] && !Shopify.designMode) return;
  try {
    
  window.HSUS = window.HSUS || {};
  if (!window.HSUS.addToCart) {
    window.HSUS.addToCart = async function (items, trigger) {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const res = await fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
      if (data.items && data.items[0]) { data.id = data.items[0].id; data.key = data.items[0].key; }
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hsus', cartData: data });
      }
      if (cart && data.sections && typeof cart.renderContents === 'function') {
        if (trigger && typeof cart.setActiveElement === 'function') cart.setActiveElement(trigger);
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      return data;
    };
  }
  if (!window.HSUS.cardsBound) {
    window.HSUS.cardsBound = true;
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-hsus-add]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      const label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      try {
        await window.HSUS.addToCart([{ id: Number(btn.dataset.hsusAdd), quantity: 1 }], btn);
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
      } catch (err) {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 2500);
        console.error(err);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }
  if (!window.HSUS.fbtBound) {
    window.HSUS.fbtBound = true;
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-hsus-add-all]');
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      const error = btn.parentElement.querySelector('.hsus-fbt__error');
      const items = btn.dataset.hsusAddAll.split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
      const label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;
      try {
        await window.HSUS.addToCart(items, btn);
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsus-main-collection"]) return;
  try {
    
  window.HSUS = window.HSUS || {};
  if (!window.HSUS.addToCart) {
    window.HSUS.addToCart = async function (items, trigger) {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const res = await fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
      if (data.items && data.items[0]) { data.id = data.items[0].id; data.key = data.items[0].key; }
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hsus', cartData: data });
      }
      if (cart && data.sections && typeof cart.renderContents === 'function') {
        if (trigger && typeof cart.setActiveElement === 'function') cart.setActiveElement(trigger);
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      return data;
    };
  }
  if (!window.HSUS.cardsBound) {
    window.HSUS.cardsBound = true;
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-hsus-add]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      const label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      try {
        await window.HSUS.addToCart([{ id: Number(btn.dataset.hsusAdd), quantity: 1 }], btn);
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
      } catch (err) {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 2500);
        console.error(err);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }
  if (!customElements.get('hsus-collection')) {
    customElements.define('hsus-collection', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-hsus-filter-form]');
        this.openBtn = this.querySelector('[data-hsus-filter-open]');
        this.scrim = this.querySelector('.hsus-coll__scrim');
        if (this.form) {
          this.form.addEventListener('change', (e) => {
            if (e.target.type === 'number') return;
            this.apply();
          });
          this.form.querySelectorAll('input[type="number"]').forEach((input) => {
            input.addEventListener('change', () => this.apply());
          });
          this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
        }
        const sort = this.querySelector('[data-hsus-sort]');
        if (sort) sort.addEventListener('change', () => this.apply());
        if (this.openBtn) this.openBtn.addEventListener('click', () => this.toggle(true));
        this.querySelectorAll('[data-hsus-filter-close]').forEach((el) => el.addEventListener('click', () => this.toggle(false)));
        this.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-filters-open')) this.toggle(false); });
      }
      apply() {
        const params = new URLSearchParams();
        const data = new FormData(this.form);
        const sort = this.querySelector('[data-hsus-sort]');
        if (sort && !data.has('sort_by')) data.append('sort_by', sort.value);
        data.forEach((value, key) => { if (String(value).trim() !== '') params.append(key, value); });
        const query = params.toString();
        window.location.href = this.form.getAttribute('action') + (query ? '?' + query : '');
      }
      toggle(open) {
        this.classList.toggle('is-filters-open', open);
        if (this.openBtn) this.openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (this.scrim) this.scrim.hidden = !open;
        document.body.style.overflow = open ? 'hidden' : '';
        if (open) {
          const first = this.querySelector('.hsus-coll__side input, .hsus-coll__side button');
          if (first) first.focus();
        } else if (this.openBtn) {
          this.openBtn.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsus-main-product"]) return;
  try {
    
  window.HSUS = window.HSUS || {};
  if (!window.HSUS.addToCart) {
    window.HSUS.addToCart = async function (items, trigger) {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const res = await fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
      if (data.items && data.items[0]) { data.id = data.items[0].id; data.key = data.items[0].key; }
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hsus', cartData: data });
      }
      if (cart && data.sections && typeof cart.renderContents === 'function') {
        if (trigger && typeof cart.setActiveElement === 'function') cart.setActiveElement(trigger);
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      return data;
    };
  }
  if (!window.HSUS.cardsBound) {
    window.HSUS.cardsBound = true;
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-hsus-add]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      const label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      try {
        await window.HSUS.addToCart([{ id: Number(btn.dataset.hsusAdd), quantity: 1 }], btn);
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
      } catch (err) {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 2500);
        console.error(err);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }
  if (!customElements.get('hsus-product')) {
    customElements.define('hsus-product', class extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-hsus-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.form = this.querySelector('form[data-type="add-to-cart-form"]');
        this.idInput = this.querySelector('[data-hsus-variant-id]');
        this.atc = this.querySelector('[data-hsus-atc]');
        this.error = this.querySelector('[data-hsus-error]');
        this.fieldsets = Array.from(this.querySelectorAll('[data-hsus-option]'));
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });

        this.fieldsets.forEach((fs, i) => fs.addEventListener('change', () => this.onOptionChange(i)));
        this.updateStickyTop = this.updateStickyTop.bind(this);
        this.updateStickyTop();
        window.addEventListener('resize', this.updateStickyTop);
        window.addEventListener('scroll', this.updateStickyTop, { passive: true });
        this.querySelectorAll('[data-hsus-thumb]').forEach((btn) => btn.addEventListener('click', () => this.showMedia(btn.dataset.hsusThumb)));
        this.querySelectorAll('[data-hsus-qty]').forEach((btn) => btn.addEventListener('click', () => this.stepQty(Number(btn.dataset.hsusQty))));
        if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
        this.fillArrival();
        this.updateOptions();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.updateStickyTop);
        window.removeEventListener('scroll', this.updateStickyTop);
      }
      updateStickyTop() {
        const header = document.querySelector('.section-header');
        let offset = 20;
        if (header) {
          const pos = getComputedStyle(header).position;
          const rect = header.getBoundingClientRect();
          if ((pos === 'sticky' || pos === 'fixed') && rect.bottom > 0) offset += rect.bottom;
        }
        this.style.setProperty('--hsus-sticky-top', offset + 'px');
      }
      selectedOptions() {
        return this.fieldsets.map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }
      findVariant(options) {
        return this.variants.find((v) => v.options.every((o, i) => o === options[i]));
      }
      bestVariant(options, changed) {
        // Keep everything up to and including the option just changed, then prefer an available
        // variant that also keeps as many of the later choices as possible.
        const fixed = (v) => v.options.every((o, i) => i > changed || o === options[i]);
        const score = (v) => v.options.reduce((n, o, i) => n + (i > changed && o === options[i] ? 1 : 0), 0);
        const pool = this.variants.filter(fixed);
        if (!pool.length) return null;
        pool.sort((a, b) => (b.available - a.available) || (score(b) - score(a)));
        return pool[0];
      }
      onOptionChange(changed) {
        let options = this.selectedOptions();
        let variant = this.findVariant(options);
        if (!variant || !variant.available) {
          const better = this.bestVariant(options, changed);
          if (better && (!variant || better.available)) variant = better;
        }
        if (variant) this.selectOptions(variant.options);
        this.updateOptions();
        this.renderVariant(variant);
      }
      selectOptions(values) {
        this.fieldsets.forEach((fs, i) => {
          fs.querySelectorAll('input').forEach((input) => { input.checked = input.value === values[i]; });
        });
      }
      updateOptions() {
        const options = this.selectedOptions();
        this.fieldsets.forEach((fs, i) => {
          fs.querySelectorAll('input').forEach((input) => {
            const parentMatch = (v) => v.options[i] === input.value && v.options.every((o, j) => j >= i || o === options[j]);
            const exists = this.variants.some(parentMatch);
            const available = this.variants.some((v) => v.available && parentMatch(v));
            const label = input.closest('label');
            label.hidden = !exists;
            label.classList.toggle('is-unavailable', exists && !available);
            input.disabled = !exists;
          });
          const label = fs.querySelector('[data-hsus-option-label]');
          if (label) label.textContent = options[i] || '';
        });
      }
      renderVariant(variant) {
        const price = this.querySelector('[data-hsus-price]');
        const was = this.querySelector('[data-hsus-was]');
        const stock = this.querySelector('[data-hsus-stock]');
        const sku = this.querySelector('[data-hsus-sku]');
        const skuWrap = this.querySelector('[data-hsus-sku-wrap]');
        if (this.error) this.error.hidden = true;
        if (!variant) {
          this.atc.disabled = true;
          this.atc.textContent = 'Unavailable';
          if (stock) { stock.textContent = 'Not available in this combination'; stock.classList.add('is-out'); }
          return;
        }
        this.idInput.value = variant.id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (price) price.textContent = this.money.format(variant.price / 100);
        if (was) {
          const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
          was.hidden = !sale;
          if (sale) was.textContent = this.money.format(variant.compare_at_price / 100);
        }
        if (stock) {
          stock.textContent = variant.available ? 'In stock' : 'Sold out';
          stock.classList.toggle('is-out', !variant.available);
        }
        if (sku) sku.textContent = variant.sku || '';
        if (skuWrap) skuWrap.hidden = !variant.sku;
        this.atc.disabled = !variant.available;
        this.atc.textContent = variant.available ? this.dataset.atcLabel : 'Sold out';
        if (variant.featured_media) this.showMedia(String(variant.featured_media.id));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      showMedia(id) {
        const slides = this.querySelectorAll('[data-hsus-slide]');
        if (!this.querySelector('[data-hsus-slide="' + id + '"]')) return;
        slides.forEach((s) => { s.hidden = s.dataset.hsusSlide !== String(id); });
        this.querySelectorAll('[data-hsus-thumb]').forEach((t) => {
          if (t.dataset.hsusThumb === String(id)) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }
      stepQty(delta) {
        const input = this.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      }
      async onSubmit(e) {
        e.preventDefault();
        if (this.atc.disabled || this.atc.getAttribute('aria-busy') === 'true') return;
        const qty = Math.max(1, parseInt(this.querySelector('input[name="quantity"]').value, 10) || 1);
        this.atc.setAttribute('aria-busy', 'true');
        if (this.error) this.error.hidden = true;
        try {
          await window.HSUS.addToCart([{ id: Number(this.idInput.value), quantity: qty }], this.atc);
        } catch (err) {
          if (this.error) { this.error.textContent = err.message; this.error.hidden = false; }
        } finally {
          this.atc.removeAttribute('aria-busy');
        }
      }
      fillArrival() {
        this.querySelectorAll('[data-hsus-arrival]').forEach((el) => {
          const min = parseInt(el.dataset.min, 10);
          const max = parseInt(el.dataset.max, 10);
          if (isNaN(min) || isNaN(max)) return;
          const addBusinessDays = (days) => {
            const d = new Date();
            let added = 0;
            while (added < days) {
              d.setDate(d.getDate() + 1);
              const day = d.getDay();
              if (day !== 0 && day !== 6) added++;
            }
            return d;
          };
          const fmt = new Intl.DateTimeFormat(this.dataset.locale || 'en-US', { month: 'short', day: 'numeric' });
          el.textContent = fmt.format(addBusinessDays(min)) + ' – ' + fmt.format(addBusinessDays(max));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsus-product-tabs"] && !Shopify.designMode) return;
  try {
    
  window.HSUS = window.HSUS || {};
  if (!window.HSUS.addToCart) {
    window.HSUS.addToCart = async function (items, trigger) {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const res = await fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
      if (data.items && data.items[0]) { data.id = data.items[0].id; data.key = data.items[0].key; }
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hsus', cartData: data });
      }
      if (cart && data.sections && typeof cart.renderContents === 'function') {
        if (trigger && typeof cart.setActiveElement === 'function') cart.setActiveElement(trigger);
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      return data;
    };
  }
  if (!window.HSUS.cardsBound) {
    window.HSUS.cardsBound = true;
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-hsus-add]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      const label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      try {
        await window.HSUS.addToCart([{ id: Number(btn.dataset.hsusAdd), quantity: 1 }], btn);
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
      } catch (err) {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 2500);
        console.error(err);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }
  if (!customElements.get('hsus-tabs')) {
    customElements.define('hsus-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            let next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = this.tabs.length - 1;
            if (next !== null) { e.preventDefault(); this.select(next); this.tabs[next].focus(); }
          });
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }
  document.addEventListener('shopify:block:select', function (e) {
    const tab = document.getElementById('HsusTab-' + e.detail.blockId);
    const host = tab && tab.closest('hsus-tabs');
    if (host) host.select(host.tabs.indexOf(tab));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hsus-related-products"] && !Shopify.designMode) return;
  try {
    
  window.HSUS = window.HSUS || {};
  if (!window.HSUS.addToCart) {
    window.HSUS.addToCart = async function (items, trigger) {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      const base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const res = await fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added to your cart.');
      if (data.items && data.items[0]) { data.id = data.items[0].id; data.key = data.items[0].key; }
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'hsus', cartData: data });
      }
      if (cart && data.sections && typeof cart.renderContents === 'function') {
        if (trigger && typeof cart.setActiveElement === 'function') cart.setActiveElement(trigger);
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      return data;
    };
  }
  if (!window.HSUS.cardsBound) {
    window.HSUS.cardsBound = true;
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-hsus-add]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      const label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      try {
        await window.HSUS.addToCart([{ id: Number(btn.dataset.hsusAdd), quantity: 1 }], btn);
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
      } catch (err) {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 2500);
        console.error(err);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  }
  if (!customElements.get('hsus-related')) {
    customElements.define('hsus-related', class extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url) return;
        const load = () => {
          fetch(url)
            .then((r) => r.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.querySelector('hsus-related [data-hsus-results]');
              const target = this.querySelector('[data-hsus-results]');
              if (fresh && target && fresh.innerHTML.trim().length) {
                target.innerHTML = fresh.innerHTML;
              } else if (!window.Shopify || !window.Shopify.designMode) {
                this.classList.add('is-empty');
              }
            })
            .catch(() => this.classList.add('is-empty'));
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) { io.disconnect(); load(); }
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(this);
        } else {
          load();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
